import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Card,
  CardBody,
  Button,
  Collapse,
  CardHeader,
  Spinner,
  CardFooter,
} from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import recovery from "@/api/recovery";
import Photo from "@/views/Components/Photo";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";
import KeyRecoveryRequests from "../KeyRecoveryRequests";
import KeyRecoveryModal from "@/views/Components/KeyRecoveryRequest";

class RecoveryDetail extends Component {
  recoveryList = new KeyRecoveryRequests();
  state = {
    isKeyRecoveryOpen: false,
    isDocsVisible: false,
    isDocsLoading: false,
    docs: "",
    photo: "",
    information: [
      {
        label: "Name",
        value: "name",
      },
      {
        label: "Account ID",
        value: "accountId",
      },
      {
        label: "Transaction Hash",
        value: "trxHash",
      },
      {
        label: "Status",
        value: "status",
      },
      {
        label: "TX Status",
        value: "trxStatus",
      },
      {
        label: "Registration Date",
        value: "date",
      },
      {
        label: "Last Update",
        value: "updateTime",
      },
      {
        label: "Reason",
        value: "comment",
      },
    ],
    loading: false,
    data: {},
  };

  onToggleKeyRecoveryModal = () => {
    this.setState(({ isKeyRecoveryOpen }) => ({
      isKeyRecoveryOpen: !isKeyRecoveryOpen,
    }));
  };

  renderActionButton = status => {
    const rowID = this.state.data.date + this.state.data.id;
    let actionName = "";
    let isCancellable = false;

    switch (status) {
      case "OPENED":
      case "VERIFIED":
      case "PREPARED":
      case "READY":
        actionName = "Cancel";
        isCancellable = true;
        break;
      case "SENT":
        actionName = "Revoke";
        isCancellable = true;
        break;
      default:
        break;
    }

    const buttons = [];

    if (actionName) {
      buttons.push(
        <Button
          key={buttons.length + rowID}
          color="primary"
          style={{ marginRight: 10 }}
          disabled={!isCancellable}
          onClick={() =>
            this.recoveryList.askCancelConfirmation(
              this.state.data,
              actionName,
              () => {
                this.reloadPage();
              },
            )
          }>
          {actionName}
        </Button>,
      );
    }

    if (status === "CREATED") {
      buttons.push(
        <Button
          key={buttons.length + rowID}
          color="success"
          style={{ marginRight: 10 }}
          onClick={() =>
            this.recoveryList.askVerify(this.state.data.accountId, () => {
              this.reloadPage();
            })
          }>
          Verify
        </Button>,
      );
    }

    if (status === "VERIFIED") {
      buttons.push(
        <Button
          key={buttons.length + rowID}
          color="success"
          style={{ marginRight: 10 }}
          onClick={() => this.onToggleKeyRecoveryModal()}>
          Complete request
        </Button>,
      );
    }

    return <>{buttons.length ? buttons : ""}</>;
  };

  componentDidMount() {
    const isAdmin = window.location.href.includes("key_recovery_requests_info");
    const id = this.props.match.params.id;
    recovery
      .getRecoveryRequestsInfo(id, isAdmin)
      .then(response => {
        Object.assign(response, {
          date: this.convertDate(response.date),
          updateTime: this.convertDate(response.updateTime),
        });
        this.setState({ data: response });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  convertDate(date) {
    if (!date) return "";
    const d = new Date(date * 1000);
    const pad = n => n.toString().padStart(2, "0");
    return (
      d.getFullYear() +
      "-" +
      pad(d.getMonth() + 1) +
      "-" +
      pad(d.getDate()) +
      " " +
      pad(d.getHours()) +
      ":" +
      pad(d.getMinutes()) +
      ":" +
      pad(d.getSeconds())
    );
  }

  reloadPage = () => {
    window.location.reload();
  };

  toggleDocsVisibility = () =>
    this.setState(({ isDocsVisible }) => ({ isDocsVisible: !isDocsVisible }));

  displayPhotos = () => {
    if (this.state.isDocsLoading) {
      return <Spinner color="danger" />;
    }

    return (
      <Row>
        <Col sm="6">
          <Photo
            src={
              this.state.data.photo
                ? `data:image/png;base64,${this.state.data.photo}`
                : ""
            }
            name="User Photo"
          />
        </Col>
        <Col sm="6">
          <Photo
            src={
              this.state.data.application
                ? `data:image/png;base64,${this.state.data.application}`
                : ""
            }
            name="Application Photo"
          />
        </Col>
      </Row>
    );
  };

  goBack = () => {
    this.props.history.goBack();
  };

  askRejectRequest = async () => {
    const html = `
        <span>
          Do you want to reject this request?
        </span>
        <br/>
      `;

    await swal({
      title: `Reject request?`,
      html,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        recovery
          .rejectRecoveryRequest(this.state.data.id)
          .then(() => {
            this.goBack();
          })
          .catch(err => {
            handleError(err);
          });
      },
    });
  };

  askApproveRequest = async () => {
    const html = `
        <span>
          Do you want to approve this request?
        </span>
      `;

    await swal({
      title: `Approve request?`,
      html,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: async reason => {
        recovery
          .approveRecoveryRequest(this.state.data.id)
          .then(() => {
            this.goBack();
          })
          .catch(err => {
            handleError(err);
          });
      },
    });
  };

  render() {
    const { accountId, name } = this.state.data;
    const isAdmin = window.location.href.includes("key_recovery_requests_info");
    return (
      <Card style={{ marginBottom: 20 }}>
        <CardHeader>Key recovery request info</CardHeader>
        <CardBody>
          <Row className="justify-content-center">
            <Col>
              <Form className="form-horizontal">
                {this.state.information.map((item, idx) => (
                  <FormGroup row className="mb-4" key={idx}>
                    <Col md="3">
                      <Label>{item.label}:</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Label>{this.state.data[item.value]}</Label>
                    </Col>
                  </FormGroup>
                ))}

                <FormGroup row className="mb-4">
                  <Col md="3">
                    <Label>Documents:</Label>
                  </Col>
                  <Col xs="12" md="9">
                    <Button
                      color="primary"
                      onClick={this.toggleDocsVisibility}
                      data-cy="show-photos">
                      {this.state.isDocsVisible ? "Hide" : "Show"}
                    </Button>
                    <Collapse isOpen={this.state.isDocsVisible}>
                      <Card style={{ marginTop: 5 }}>
                        <CardBody style={{ width: "100%" }}>
                          {this.displayPhotos()}
                        </CardBody>
                      </Card>
                    </Collapse>
                  </Col>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </CardBody>
        <CardFooter>
          {this.state.data.status === "READY" && !isAdmin && (
            <>
              <Button
                color="primary"
                style={{ marginRight: 10 }}
                onClick={() => this.askRejectRequest()}
                data-cy="back">
                Reject
              </Button>
              <Button
                color="success"
                type="submit"
                data-cy="submit"
                onClick={() => this.askApproveRequest()}>
                Approve
              </Button>
            </>
          )}
          {isAdmin && this.renderActionButton(this.state.data.status)}
          <Button
            style={{ float: "right" }}
            onClick={this.goBack}
            data-cy="back">
            <i className="fa fa-arrow-left mr-2 " />
            Back
          </Button>
        </CardFooter>
        <KeyRecoveryModal
          isOpen={this.state.isKeyRecoveryOpen}
          isKeyRecovery={true}
          onModalClose={this.onToggleKeyRecoveryModal}
          userData={{ accountId, name }}
          onLoadTableData={this.reloadPage}
        />
      </Card>
    );
  }
}

export default RecoveryDetail;
